module.exports = __webpack_public_path__ + "img/perspective-01.3c4796b7.svg";